import React from "react";
import Card from "../../../common/element/Card";
import Heading from "../../../common/element/Heading";
import BtnPrimary from "../../../common/element/Buttons/btnPrimary";
import { Link, useLocation } from "react-router-dom";
import moment from "moment";
const PaymentInvoiceSuccess = () => {
  const location = useLocation();
  let invoiceData = location?.state?.data;
  return (
    <div
      style={{ backgroundColor: `#eff8ff` }}
      className="flex justify-center min-h-screen pr-6 pl-6"
    >
      <div className="min-h-screen justify-center flex  py-12 px-4">
        <div className="flex-col items-center justify-center flex">
          <div className="flex items-center mb-6">
            <img className="brand-img" src="/assets/logo.svg" alt="conserve" />
          </div>
          <Heading className="text-center mb-3">Payment successful</Heading>
          <p className="text-base text-gray-600 text-center font-semibold max-w-lg mb-7">
            Thank you for your payment. A confirmation of this <br />{" "}
            transaction has been sent to your email.
          </p>
          <Card className="w-440 rounded-xl   block-shadow w-100 px-10 py-8 mb-7">
            <div className="flex flex-col mb-7">
              <p className="text-gray-700 font-bold text-base mb-1">
                Annual License Fee
              </p>
              <span className="text-gray-700">${invoiceData?.amount}</span>
            </div>
            <div className="flex flex-col mb-7">
              <p className="text-gray-700 font-bold text-base mb-1">
                License Period
              </p>
              <p className="text-gray-700">
                {moment(new Date()).format("DD/MM/YYYY")} -{" "}
                {moment(invoiceData?.end_date).format("DD/MM/YYYY")}
              </p>
            </div>
            <div className="flex flex-col">
              <p className="text-gray-700 font-bold text-base mb-1">
                Invoice Number
              </p>
              <span className="text-gray-700">
                {invoiceData?.xero_invoice_number}
              </span>
            </div>
          </Card>
          <div className="px-10 w-full">
            <BtnPrimary className="text-xs h-9">
              <Link to="/login">Continue to Conserve App</Link>
            </BtnPrimary>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentInvoiceSuccess;
